import { useMutation } from "@tanstack/react-query";

import { UpdateContactRequestBody } from "@seneca/tutoring-service-types";

import { getClient } from "services";

const updateData = async (partialContactProperties: UpdateContactRequestBody) =>
  getClient("tutoringService").updateContact(partialContactProperties);

export function useUpdateContact({ onSuccess }: { onSuccess?: () => void }) {
  return useMutation({
    mutationKey: ["tutoring-leads-form-update"],
    mutationFn: updateData,
    onSuccess
  });
}
